import { ApiProperty } from "@nestjs/swagger";

export class SaleOrderItemsRequest{
  @ApiProperty()  
  saleOrderId:number;
  @ApiProperty()
  saleOrderItemId:number;
  @ApiProperty()
  plantId?:number;
  }